import React from "react";
import ModalLauncher from "../../util/ModalLauncher";
import NoteForm from "./NoteForm";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import { translations, locale } from "../../util/i18n";

const CreateNoteModal = (props) => {
  const modalContent = () => {
    return <NoteForm url={props.createUrl} method={"POST"}></NoteForm>;
  };

  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <ModalLauncher
        buttonId="create-note"
        buttonText="units.notes.create-note"
        content={modalContent()}
        title="units.notes.create-note"
      />
    </IntlProvider>
  );
};

CreateNoteModal.propTypes = {
  createUrl: PropTypes.string,
};

export default CreateNoteModal;
